var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Input',_vm._g(_vm._b({attrs:{"type":"number"},model:{value:(_vm.valueSync),callback:function ($$v) {_vm.valueSync=$$v},expression:"valueSync"}},'Input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }